export default "__VITE_ASSET__Dkyb7MXM__"